import { DeliveryTimeZone, deliveryTimeZoneLabels } from "./consts";

export const getDeliveryTimeZoneLabel = (timezone: DeliveryTimeZone) => {
  return deliveryTimeZoneLabels[timezone] ?? deliveryTimeZoneLabels.free;
};
